import GroupIcon from "@mui/icons-material/Group";
import { Button, Chip, Grid, styled, Typography } from "@mui/material";
import { types } from "api";
import clsx from "clsx";
import { useAuthStatus } from "helpers/useAuthStatus";
import { Link } from "react-router-dom";

const PREFIX = "GroupListItem";

const classes = {
	root: `${PREFIX}-root`,
	tag: `${PREFIX}-tag`,
	Owner: `${PREFIX}-Owner`,
	CoOwner: `${PREFIX}-CoOwner`,
	titleTagContainer: `${PREFIX}-titleTagContainer`,
	overflowContainer: `${PREFIX}-overflowContainer`,
};

const StyledPaper = styled(Grid)(({ theme }) => ({
	[`&.${classes.root}`]: {
		width: "100%",
		margin: 0,
		marginBottom: theme.spacing(1),
		padding: theme.spacing(2),
		background: theme.palette.background.paper,
		borderRadius: theme.spacing(1),
	},
	[`& .${classes.titleTagContainer}`]: {
		flexGrow: "true",
		justifyContent: "space-between",
	},
	[`& .${classes.overflowContainer}`]: {
		marginTop: "-5px",
	},

	[`& .${classes.tag}`]: {
		background: theme.palette.primary.main,
		color: "white",
	},

	[`& .${classes.Owner}`]: {
		background: theme.palette.success.main,
		color: "white",
		marginTop: "5px",
	},

	[`& .${classes.CoOwner}`]: {
		background: theme.palette.warning.main,
		color: "white",
		marginTop: "5px",
	},
}));

export interface GroupListItemProps {
	group: types.Group;
	labelId: string;
	getPath: (groupId: string) => string;
}

export const GroupListItem = ({
	group,
	labelId,
	getPath,
}: GroupListItemProps): JSX.Element => {
	const { role } = useAuthStatus();

	return (
		<StyledPaper
			container
			spacing={2}
			data-testid={labelId}
			className={classes.root}
		>
			<Grid item xs={4}>
				<Grid
					container
					flexDirection="row"
					className={classes.titleTagContainer}
				>
					<Typography align="left">{group.name}</Typography>
					<Grid item className={classes.overflowContainer}>
						{role !== "student" && (
							<Chip
								label={group.owners.length > 1 ? ["Co-owners"] : ["Owner"]}
								className={clsx({
									[classes.CoOwner]: group.owners.length > 1,
									[classes.Owner]: group.owners.length === 1,
								})}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={4} textAlign="center">
				<GroupIcon fontSize="large" />
				<Typography>{group.students.length} students</Typography>
			</Grid>
			<Grid item xs={4} textAlign="end">
				<Button
					variant="contained"
					component={Link}
					to={getPath(group.groupId)}
					data-testid="view-group-btn"
				>
					View
				</Button>
			</Grid>
		</StyledPaper>
	);
};
